import axios from 'axios';

const BASE_URL = '/app/noteFunnel';

export const createNoteApplied = async (name) => {
    const { data } = await axios.post(BASE_URL, name, {
        headers: {
            'Content-Type': 'text/html',
        },
    });

    return data;
};

export const getNoteAppliedConfig = async (marketingNoteId) => {
    const params = {
        marketingNoteId,
    };

    const { data } = await axios.get(`${BASE_URL}/noteApplied`, { params });

    return data;
};

export const updateNoteApplied = async (marketingNoteId, payload) => {
    await axios.put(`${BASE_URL}/${marketingNoteId}`, payload);
};

export const syncNoteAppliedLabel = async (cell) => {
    const marketingNoteId = cell.value?.marketingNoteId ?? 0;
    const newName = cell.value?.name ?? '';

    if (marketingNoteId && newName) {
        await axios.put(`${BASE_URL}/${marketingNoteId}/name`, newName, {
            headers: {
                'Content-Type': 'text/html',
            },
        });
    }
};
